import './App.css';
import Dashboard from './Respondent/Dashboard';
import TorfactsApp from './website/torfacts';
import DashboardPanel from './Respondent/PanelDashboard';
import toast, { Toaster } from 'react-hot-toast';
//import Navigation from './website/auth/Navigation';
import Layout from './Respondent/Layout';

import {HashRouter as Router, Routes, Route } from 'react-router-dom';
import ReferFriend from "./Respondent/ReferFriend/ReferFriend"; 
import PointsBook from "./Respondent/PointsBook/PointsBook";
import Redeem from "./Respondent/Redeem/Redeem";         
import Profile from "./Respondent/Profile/Profile";  
import FAQ from './website/OtherPages/FAQ';
import TermsAndConditions from './website/OtherPages/TermsAndConditions';
import PrivacyPolicy from './website/OtherPages/PrivacyPolicy';
import Releases from './website/OtherPages/Releases';
import ScrollToTop from './ScrollToTop';
import Ratings from "./Respondent/Ratings/Ratings"
import ConnectionHub from './Respondent/Connections/ConnectionHub';

function App()
 {
  return (
      <div className="App">
       <Toaster />
        <ScrollToTop />
         <Routes>
             <Route path="/" element={<TorfactsApp />} />
             <Route path="/FAQ" element={<FAQ />} />
             
             <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
             <Route path="/privacy-policy" element={<PrivacyPolicy />} />
             <Route path='/releases' element = {<Releases />} />

             <Route element={<Layout />} >
             <Route path="/dashboard" element={<Dashboard />} />
             <Route path="/refer-friend" element={<ReferFriend />} />
             <Route path="/points-book" element={<PointsBook />} />
             <Route path="/redeem" element={<Redeem />} />
             <Route path="/profile" element={<Profile />} />
             <Route path="/ratings" element={<Ratings />} />
             <Route path="/connections" element={<ConnectionHub />} />
             </Route>
             
          </Routes>
    </div>
    
    );}
    
    export default App;